import { CommonModule } from '@angular/common';
import { Component, computed, OnInit, signal, OnDestroy } from '@angular/core';
import { Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { HeaderComponent } from './shared/components/header/header.component';
import { AppRoutes } from './shared/constants/app-routes';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule, HeaderComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit, OnDestroy {
  public isLoading = signal(false);
  public currentPath = signal('/');
  private routerSubscription?: Subscription;

  public showBackButton = computed(() => {
    const path = this.currentPath();
    return path !== AppRoutes.HOME && path !== '/';
  });

  public showHeader = computed(() => {
    const path = this.currentPath();
    return path !== AppRoutes.UNAUTHORIZED;
  });

  constructor(
    private router: Router
  ) {}

  ngOnInit(): void {
    // Configurar tema inicial (si es necesario en el futuro)
    if (typeof document !== 'undefined') {
      document.documentElement.setAttribute('data-theme', 'light');
    }

    // Suscribirse a los cambios de ruta
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentPath.set(event.urlAfterRedirects);
      });
  }

  ngOnDestroy(): void {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
